export const setLocalStateData = (state, payload) => {
    return {
        ...state,
        localStateData: {
            ...state.localStateData,
            ...payload
        }
    };
};